/**
 * Long Group
 * @param fb : FormBuilder
 */
export function longGroup (fb: any): any {
   return fb.group({
        text: ['']
    });
}
